import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { asyncFetch } from '../helperFunctions';
import { setAppFeatures } from './redux';

export default () => {
  const dispatch = useDispatch();
  const featuresList = useSelector(state => state.features.featuresList);
  const loggedUser = useSelector(state => state.auth.user);

  useEffect(() => {
    if (loggedUser && !featuresList.loaded) {
      (async () => {
        const response = await asyncFetch(
          `${process.env.REACT_APP_TECHNICIANS_API}/Feature/get-user-features`
        );

        if (response && Object.keys(response).includes('features')) {
          dispatch(setAppFeatures({ features: response.features, loaded: true }));
        }
      })();
    }
  }, [loggedUser, featuresList, dispatch]);

  return <></>;
};
